import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { CommonAxiosGet } from "../../CommonUtils/CommonAxios";
import { config } from "../../CommonUtils/CommonURLS";
import * as bie from "react-bootstrap";
import manualPDF from './jnbmapmanual.pdf';
import CommonFormHeading from "../../CommonUtils/CommonFormHeading";
export default function AfflGeoLocations() {
    const instName = sessionStorage.getItem('instName');

    const [getdata, setData] = useState([]);
    function GetGeoData() {
        let url = config.url.API_URL + `getCollLatLongDetails`
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setData(res?.data?.CollegeLatLongDetails[0]);
            } else {
                setData([]);
            }
        });
    }
    useEffect(() => {
        GetGeoData();
    }, []);
    return (
        <>                <CommonFormHeading heading={"GeoLocation"} />

            <Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-3" >
                <div className="px-1">
                    <div className="inner-herbpage-service-title-sub">
                        <h1 className=""> Geo-Position of the College (Must be Entered using Android App.)</h1>
                    </div>
                    <div className="table-responsive">
                        <bie.Row>
                            <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                                <a href="https://play.google.com/store/apps/details?id=in.apcfss.jnb.bio" style={{ textDecoration: "underline", color: "blue", fontSize: "18px" }}
                                    target="_blank">(a) Click here to download the Android App</a></bie.Col>
                            <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>  <a href={manualPDF} style={{ textDecoration: "underline", color: "blue", fontSize: "18px" }} target="_blank" rel="noopener noreferrer">
                                (b) Click here to download the User Manual for Android App</a> </bie.Col></bie.Row>
                        <br />

                        <table className="table table-condensed table-bordered table-sm table-responsive table-stripped affl-table affl-table1">
                            <thead>
                                <tr>
                                    <th>Latitude</th>
                                    <th>Longitude</th>
                                    <th>Location Name</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr>

                                    <td>{getdata?.lat ?? '-'}</td>
                                    <td>{getdata?.long ?? '-'}</td>
                                    <td className="text-left"> {instName} &emsp;- &emsp;{getdata?.lat_long_name ?? '-'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Container>
        </>
    )
}
